var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetSuggestiveResults, Vendd.Search, function (envelope) {
            var options = {
                url: 'SearchService.svc/GetSuggestiveResultsViewModel',
                data: {
                    searchTerm: envelope.message.data.searchTerm,
                    category: envelope.message.data.category
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetSuggestiveResultsSuccess(response));
            };

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetSuggestiveResultsFailed(response));
            };

            Vendd.Service.call(options);
        });

    Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResults, Vendd.Search, function (envelope) {

        function onSuccess(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetProductSuggestiveResultsSuccess(response));
        }

        function onFailure(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetProductSuggestiveResultsFailed(response));
        }

        var options = {
            url: 'SearchService.svc/GetProductSuggestiveResultsViewModel',
            data: {
                searchTerm: envelope.message.data.searchTerm,
                maxResults: envelope.message.data.maxResults,
                pageSize: envelope.message.data.pageSize,
                pageNumber: envelope.message.data.pageNumber
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });


    Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveElasticResults, Vendd.Search, function (envelope) {

        var options = {
            url: document.getElementById("base_engine").href + "esqueryindex" + (envelope.message.data.query ? envelope.message.data.query : ""),
            data: {
                type: "products",
                query: envelope.message.data.searchTerm,
                pagefrom: envelope.message.data.pageFrom,
                pagesize: envelope.message.data.pageSize,
                path: envelope.message.data.path ? envelope.message.data.path : "?hidefromsearch=1"
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetProductSuggestiveResultsElasticSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Search, new Vendd.Search.Messages.GetProductSuggestiveResultsElasticFailed(response));
        }

        Vendd.Service.call(options);
    });
    return Vendd;

})(Vendd || {});
